import { AppRouteURI } from 'router/RoleBasedAccess'

export const AppActionType = Object.freeze({
    APP_BUSY: 'App:: Set application busy',
    REMOVE_TOAST_MESSAGE: 'App:: Remove toast message',
    SET_TOAST_MESSAGE: 'App:: Show toast message',
    SET_DRAWER_STATE: 'App:: Show/Hide Side list',
    TOGGLE_ORIENTATION: 'App:: toggle orientation of screens',
})

export const appLinks = [{ text: 'Your Dashboard', route: AppRouteURI.HOME }]
export const userSettings = [
    {
        text: 'Users',
        route: AppRouteURI.MEMBERS,
    },
    {
        text: 'Invites',
        route: AppRouteURI.INVITES,
    },
    // {
    //     text: 'Groups',
    //     route: AppRouteURI.GROUPS,
    // },
    // {
    //     text: 'Permissions',
    //     route: AppRouteURI.PERMISSIONS,
    // },
    // {
    //     text: 'App Security',
    //     route: AppRouteURI.SECURITY,
    // },
    {
        text: 'Analytics',
        route: AppRouteURI.ANALYTICS,
    },
    {
        text: 'Your Profile',
        route: AppRouteURI.SETTINGS,
    },
]

export const mobileUserSettings = [
    ...userSettings,
    {
        text: 'Logout',
        route: AppRouteURI.LOGOUT,
    },
]

export const desktopUserSettings = [
    { text: 'Dashboard', route: AppRouteURI.HOME },
    ...userSettings,
]
